import { FlowParams } from '@frame/components/oe/generated/screen-types'
import { FlowDefinition } from '@frame/components/oe/types'

import { FetchClient } from './types'

const BASE_PREFIX = `/api/truework-js/client/flow`

export const orchestrationEngineEndpoints = (fetchClient: FetchClient) => {
  return {
    async getFlowDefinition({ flowParams }: { flowParams: FlowParams }) {
      return fetchClient<FlowDefinition>(`${BASE_PREFIX}/`, {
        method: 'POST',
        body: JSON.stringify({ flowParams }),
      })
    },
    async emitEvent({
      eventName,
      screenTypeName,
      eventPayload,
      sentAt,
    }: {
      eventName: string
      screenTypeName: string | null
      eventPayload: Record<string, unknown>
      sentAt: string
    }) {
      return fetchClient<{ ok: boolean }>(`${BASE_PREFIX}/event/`, {
        method: 'POST',
        body: JSON.stringify({ eventName, screenTypeName, eventPayload, sentAt }),
      })
    },
  }
}
